import React, { useCallback } from "react";
import {
  AppDatePicker,
  AppInput,
  AppRemixIcon,
  AppTextArea,
} from "@/layout/AppComponents";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import ReactDOMServer from "react-dom/server";
import Translator from "../../../../../../components/helpers/Translator";
import { axiosPath } from "../../../../../../../routing/helpers/router";
import errorHandler from "@/layout/components/error/ErrorHandler";
import colors from "../../../../../../../constants/colors";

export default function CorrectiveActionsTaskUpdateHome(props) {
  const {
    taskID,
    selectedTaskUpdate,
    modulePermissions,
    onEdit,
    onClose,
    onToggleClosed,
    onUpdateClosedStamp,
  } = props;
  const { moduleBridgeHex } = useParams();
  const dispatch = useDispatch();
  const level2 = useSelector((state) => state.currentPage?.levels?.level2);
  const userBridge = useSelector(
    (s) => s?.module?.[moduleBridgeHex]?.userBridge
  );

  const handleDownloadTaskUpdateFile = useCallback(
    async (fileID) =>
      axios
        .post(
          axiosPath(
            "api_r_user_module_correctiveActions_taskUpdate_downloadFile"
          ),
          {
            moduleBridgeHex,
            fileID,
          }
        )
        .then((r) => (window.location = r.data?.url))
        .catch((e) => dispatch(errorHandler(e))),
    [selectedTaskUpdate]
  );

  const handleChangeTaskStatus = useCallback(
    async () =>
      axios
        .post(
          axiosPath(
            "api_r_user_module_correctiveActions_taskUpdate_changeState"
          ),
          {
            moduleBridgeHex,
            taskUpdateID: selectedTaskUpdate?.id,
          }
        )
        .then(() => onToggleClosed())
        .catch((e) => dispatch(errorHandler(e))),
    [selectedTaskUpdate]
  );

  const handleChangeClosedStamp = useCallback(
    async (value) =>
      axios
        .post(
          axiosPath(
            "api_r_user_module_correctiveActions_taskUpdate_changeClosedStamp"
          ),
          {
            moduleBridgeHex,
            taskUpdateID: selectedTaskUpdate?.id,
            closedStamp: value,
          }
        )
        .then(() => onUpdateClosedStamp())
        .catch((e) => dispatch(errorHandler(e))),
    [selectedTaskUpdate]
  );

  return (
    <>
      <div className="row-no-margin">
        <div className="row">
          <div className="col-lg-12">
            <h3>
              {`Acción ${selectedTaskUpdate?.date} - ${selectedTaskUpdate?.type?.name} - ${selectedTaskUpdate?.user}`}
              <AppRemixIcon
                icon="close"
                className="float-right pointer mr-2"
                size={16}
                onClick={onClose}
                title={ReactDOMServer.renderToString(
                  <Translator
                    file="module-correctiveActions"
                    name="module.ca.close-task"
                  />
                )}
              />
              {!level2?.[taskID]?.blocked &&
                userBridge?.permissions?.level !== 2 && (
                  <>
                    {!selectedTaskUpdate?.closedStamp && (
                      <AppRemixIcon
                        icon="edit"
                        className="float-right pointer mr-2"
                        size={16}
                        onClick={onEdit}
                        title="Editar"
                      />
                    )}
                    {modulePermissions?.correctiveActions
                      ?.taskUpdateClosedSystem && (
                      <AppRemixIcon
                        icon={
                          selectedTaskUpdate?.closedStamp
                            ? "arrow-go-back"
                            : "checkbox"
                        }
                        className="float-right pointer mr-2"
                        size={16}
                        color={colors.success}
                        title={ReactDOMServer.renderToString(
                          <Translator
                            file="module-correctiveActions"
                            name={
                              level2?.[taskID]?.closedStamp
                                ? "reopen.action"
                                : "close.action"
                            }
                          />
                        )}
                        onClick={handleChangeTaskStatus}
                      />
                    )}
                    {/* {modulePermissions?.caAutoCalc &&
                    modulePermissions.caAutoCalc == 1 && (
                      <>
                        {!selectedTaskUpdate.closedStamp && (
                          <AppRemixIcon
                            icon="pencil-ruler-2"
                            title={ReactDOMServer.renderToString(
                              <Translator
                                file="module-legalCompliance"
                                name="edit.implementation.and.efficiency"
                              />
                            )}
                            className="float-right pointer mr-2"
                            size={16}
                            onClick={() => setShowEditCaCalc(true)}
                          />
                        )}
                        <AppModal
                          show={showEditCaCalc}
                          title={ReactDOMServer.renderToString(
                            <Translator
                              file="module-legalCompliance"
                              name="edit.implementation.and.efficiency"
                            />
                          )}
                        >
                          <CorrectiveActionsEditTaskUpdateCalcs
                            plantObligationID={1}
                            taskID={taskID}
                            selectedTaskUpdate={selectedTaskUpdate}
                            modulePermissions={modulePermissions}
                            onCreated={(r) => {
                              setIsEditTaskUpdateMode(false);
                              setSelectedTaskUpdate(false);
                              setShowEditCaCalc(false);
                            }}
                          />
                        </AppModal>
                      </>
                    )} */}
                  </>
                )}
            </h3>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-4">
            <AppInput
              title={ReactDOMServer.renderToString(
                <Translator
                  file="module-legalCompliance"
                  name="creation.date"
                />
              )}
              value={selectedTaskUpdate?.date}
              isReadOnly
            />
          </div>
          {modulePermissions?.correctiveActions?.taskUpdateClosedSystem && (
            <div className="col-lg-4">
              <AppInput
                title={ReactDOMServer.renderToString(
                  <Translator
                    file="module-legalCompliance"
                    name="module.lc.limit.date"
                  />
                )}
                value={selectedTaskUpdate?.limitDate}
                placeholder="dd/mm/yyyy"
                isReadOnly
              />
            </div>
          )}
          <div className="col-lg-4">
            <AppInput
              title={ReactDOMServer.renderToString(
                <Translator
                  file="module-correctiveActions"
                  name="module.ca.task-type-2"
                />
              )}
              value={selectedTaskUpdate?.type?.name}
              placeholder="dd/mm/yyyy"
              isReadOnly
            />
          </div>
        </div>
        {modulePermissions?.correctiveActions?.taskUpdateClosedSystem &&
          selectedTaskUpdate?.closedStamp && (
            <div className="row">
              <div className="col-lg-4">
                <AppDatePicker
                  title={ReactDOMServer.renderToString(
                    <Translator
                      file="module-correctiveActions"
                      name="module.ca.closedStamp"
                    />
                  )}
                  value={selectedTaskUpdate?.closedStamp}
                  onChange={handleChangeClosedStamp}
                  placeholder="dd/mm/yyyy"
                  showMonthDropdown
                  showYearDropdown
                />
              </div>
            </div>
          )}
        <div className="row">
          <div className="col-lg-8">
            <AppTextArea
              title={ReactDOMServer.renderToString(
                <Translator
                  file="module-correctiveActions"
                  name="module.ca.description"
                />
              )}
              value={
                <div
                  dangerouslySetInnerHTML={{
                    __html: selectedTaskUpdate?.description,
                  }}
                />
              }
              icon={<AppRemixIcon icon="double-quotes-l" noVariants />}
              height={
                modulePermissions?.caAutoCalc &&
                modulePermissions.caAutoCalc == 1
                  ? "150px"
                  : "204px"
              }
              isReadOnly
            />
          </div>
          <div className="col-lg-4">
            {modulePermissions?.correctiveActions?.taskUpdateResponsibles && (
              <AppTextArea
                title={ReactDOMServer.renderToString(
                  <Translator
                    file="module-legalCompliance"
                    name="responsibles"
                  />
                )}
                value={
                  <ul style={{ paddingLeft: "6px" }}>
                    {selectedTaskUpdate.responsibles.map((r, i) => (
                      <li
                        key={i}
                        title={ReactDOMServer.renderToString(
                          <Translator
                            file="module-legalCompliance"
                            name="responsible"
                          />
                        )}
                      >
                        {r.name}
                      </li>
                    ))}
                  </ul>
                }
                icon={<AppRemixIcon icon="user" />}
                height={
                  modulePermissions?.caAutoCalc &&
                  modulePermissions.caAutoCalc === 1
                    ? "107px"
                    : "160px"
                }
                isReadOnly
              />
            )}
            {selectedTaskUpdate.files.length > 0 ? (
              <>
                <h4>
                  <AppRemixIcon
                    icon="attachment-2"
                    className="mr-1"
                    noVariants
                  />
                  <b>
                    <Translator file="module-correctiveActions" name="files" />:
                  </b>
                </h4>
                {selectedTaskUpdate.files.map((f) => (
                  <div
                    key={f?.id}
                    id={f?.id}
                    className="pointer text-info mb-1"
                    onClick={() => handleDownloadTaskUpdateFile(f?.id)}
                  >
                    {f?.name}
                  </div>
                ))}
              </>
            ) : (
              <>
                <span className="text-muted">
                  <Translator file="module-correctiveActions" name="no.files" />
                </span>
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
}
